import React, { pure } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import MUISnackbar from '@material-ui/core/Snackbar'
import { Info } from '@material-ui/icons'

const useStyles = makeStyles(theme => ({
  message: {
    marginTop: 0,
    marginBottom: 10,
    color: '#3393F3',
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
    fontSize: 12,
    fontWeight: 600,
    '& svg': {
      marginRight: 5,
      height: 14,
      width: 14,
    },
  },
  snackbar: {
    maxWidth: 480,
    position: 'absolute',
    '& .MuiSnackbarContent-root': {
      background: '#fff',
      padding: '16px 18px',
      '& .MuiSnackbarContent-action': {
        '& svg': {
          height: 14,
          width: 14,
        },
      },
      '& .MuiSnackbarContent-message': {
        padding: 0,
        '& p': {
          color: '#181818',
          lineHeight: '18px',
        },
      },
    },
  },
}))

const Snackbar = ({ message, id }) => {
  const classes = useStyles()
  const showing = message ? true : false
  const getPostionSnackBar = (id) => {
    if (id === 1 || id === 4) {
      return {
        top: '-200px',
        left: '70px',
      }
    } else if (id === 7) {
      return {
        top: '-300px',
        left: '70px',
      }
    } else {
      return {
        top: '-100px',
        left: '70px',
      }
    }
  }
  return (
    <MUISnackbar
      className={classes.snackbar}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      transitionDuration={100}
      open={showing}
      style={getPostionSnackBar(id)}
      message={
        message && (
          <>
            <h4 className={classes.message}>
              <Info />
              {message.title}
            </h4>
            <p style={{ margin: 0, fontSize: 12 }}>{message.text}</p>
          </>
        )
      }
    />
  )
}

export default React.memo(Snackbar)
